<template>
  <swiper :options="swiperOptions">
    <swiper-slide v-for="(item, index) in list" :key="index">
      <img class="banner-image" :src="item.url">
    </swiper-slide>
    <div slot="pagination" class="swiper-pagination" />
    <img slot="button-prev" class="swiper-prev" src="@/assets/images/icon-left-arrow.png">
    <img slot="button-next" class="swiper-next" src="@/assets/images/icon-right-arrow.png">
  </swiper>
</template>

<script>
import { swiper, swiperSlide } from 'vue-awesome-swiper'

export default {

  components: {
    swiper,
    swiperSlide
  },
  props: {
    list: {
      type: Array,
      default() {
        return []
      }
    },

    options: {
      type: Object,
      default() {
        return {}
      }
    }
  },

  data() {
    return {}
  },

  computed: {
    /* 轮播图 */
    swiperOptions() {
      return Object.assign(this.options, {
        loop: true,
        autoHeight: true,
        autoplay: {
          disableOnInteraction: false
        },
        navigation: {
          prevEl: '.swiper-prev',
          nextEl: '.swiper-next'
        },
        pagination: {
          el: '.swiper-pagination',
          clickable: true
        }
      })
    }
  }
}
</script>

<style lang='scss' scoped>
@mixin mixin() {
    position: absolute;
    top: 50%;
    z-index: 2;
    width: 4.375%;
    max-width: 84px;
    transform: translateY(-50%);
    cursor: pointer;
}

.swiper-container {
  .swiper-prev {
    @include mixin;
    left: 8%;
  }
  .swiper-next {
    @include mixin;
    right: 8%;
  }
  /deep/ .swiper-pagination {
    .swiper-pagination-bullet {
      background-color: #fff;
      opacity: 1;
      margin: 0 7px;
    }
    .swiper-pagination-bullet-active {
      background-color: #EFA843;
    }
  }
  .swiper-slide {
    text-align: center;
    .banner-image {
      width: 100%;
    }
  }
}
</style>
